export default __webpack_public_path__ + "static/media/software-1.a9c1cef8.png";